var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgReset = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8798ad;opacity:0;}.a,.b{stroke:#8798ad;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-9 -1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 40,
  height: 40,
  transform: "translate(2 2)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 9.991)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M1,4v6H7"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M3.51,15A9,9,0,1,0,5.64,5.64L1,10"
}))))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReset, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reset.c30c5535.svg";
export { ForwardRef as ReactComponent };